import * as common from '@/store/common/mutation-types';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const STATE_INIT = 'STATE_INIT';
export const STATE_APCN_INIT = 'STATE_APCN_INIT';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const PAGING_INFO = 'PAGING_INFO';
export const APCN_INFO = 'APCN_INFO';
export const APCN_SAVE_INFO = 'APCN_SAVE_INFO';
export const POPUP_SEARCH_PARAM = 'POPUP_SEARCH_PARAM';


export default {
	...common,
	SEARCH_PARAM,
	STATE_INIT,
	STATE_APCN_INIT,
	DEFAULT_ASSIGN,
	PAGING_INFO,
	APCN_INFO,
	APCN_SAVE_INFO,
	POPUP_SEARCH_PARAM
};
